import { FeatureFlagNames } from './feature-flag.types';

export const APP_FLAG_MAP: Record<string, FeatureFlagNames> = {
    cloak: FeatureFlagNames.intappsBrokerageAccounts,
    guild: FeatureFlagNames.intappsVendors,
    cache: FeatureFlagNames.intappsBankFiles,
    userAccess: FeatureFlagNames.intappsUserAccess,
    adminRoles: FeatureFlagNames.intappsAdminRoles,
    bankFileExplorer: FeatureFlagNames.intappsBankFiles,
    activity: FeatureFlagNames.intappsActivity,
};
